<template>
  <div class="mnp-in-start ">
    <div class="mnp-in-start-content container">
      <div class="container-box">
        <div class="content-limiter">
          <slot name="txtBefore"></slot>
        </div>
      </div>
      <div class="container-box text-base">
        <div class="content-limiter">
          <h2 class="text-3xl">Rufnummer mitnehmen</h2>
          <slot v-if="portationTime_ === 'CONTRACT_END'" name="requirementsContractEnd"></slot>
          <slot v-if="portationTime_ === 'AS_SOON_AS_POSSIBLE'" name="requirementsASAP"></slot>
          <form>
            <fieldset label="Zeitpunkt der Rufnummer mitnahme" label-class="visually-hidden">
              <div class="inputs-container">
                <div class="input-field">
                  <div class="radio-group">
                    <label for="ce">
                      <input
                        id="ce"
                        type="radio"
                        name="portationTimeCE"
                        value="CONTRACT_END"
                        v-model="portationTime_"
                        @input="$v.portationTime.$touch"
                      />
                      <span class="custom-radio"></span>

                      <span>
                        <slot name="portationTimeContractEnd">
                          <p>zum Ende der Vertragslaufzeit</p>
                        </slot>
                      </span>
                    </label>
                    <label for="asap">
                      <input
                        id="asap"
                        type="radio"
                        name="portationTimeASAP"
                        value="AS_SOON_AS_POSSIBLE"
                        v-model="portationTime_"
                        @input="$v.portationTime.$touch"
                      />
                      <span class="custom-radio"></span>

                      <span>
                        <slot name="portationTimeASAP">
                          <p>vor Ende der Vertragslaufzeit</p>
                        </slot>
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset label="Zustimmen der Bedingungen">
              <div class="checkbox-group input-field">
                <label class="checkbox-class" for="mnp-in-portation-consent">
                  <div class="input-wrapper">
                    <input
                      id="mnp-in-portation-consent"
                      type="checkbox"
                      v-model="portationConsent_"
                      required
                      @input="$v.portationConsent.$touch"
                      @click="$v.portationConsent.$reset"

                      :class="{
                        'input--invalid': $v.portationConsent.$dirty && !isValid('portationConsent'),
                        'input--valid': $v.portationConsent.$dirty && isValid('portationConsent')
                      }"
                      aria-errormessage="consent-error"
                      aria-describedby="consent-hint"
                    />
                    <span class="custom-checkbox"></span>
                  </div>
                  <div>
                    <slot name="portationConsent">
                      <p>Hiermit bestätige ich, dass ich die Voraussetzungen gelesen und erfüllt habe.</p>
                    </slot>
                    <small id="consent-hint" class="sr-only">Pflichtfeld</small>
                    <div id="consent-error" v-if="!isValid('portationConsent') && $v.portationConsent.$dirty">
                      <p class="error-feedback text-sm">
                        <br />Bitte bestätige, dass du die Voraussetzungen gelesen hast und erfüllst.
                      </p>
                    </div>
                  </div>
                </label>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
      <div class="container-box text-base">
        <div class="content-limiter">
          <slot name="txtAfter"></slot>
        </div>
      </div>
      <div class="flex-justify-content-end">
        <button @click="next()" :disabled="loading" class="button button--primary">Weiter</button>
      </div>
    </div>
  </div>
</template>

<script>
import slotProxy from '@/mixins/slotProxy'
import syncProperty from '@/mixins/syncProperty'
import processSteps from '@/mixins/processSteps'
import isValid from '@/mixins/isValid'
import { stepName as nextProcessStep } from './Data.vue'
import { mapActions, mapMutations } from 'vuex'
import { required, sameAs } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'

export const stepName = 'mnpInStart'
export default {
  name: 'MnpInStart',
  data() {
    return {
      loading: false
    }
  },
  methods: {
    ...mapMutations('mnpIn', ['goToStep']),
    ...mapActions('mnpIn', ['storeAllStartData']),
    next() {
      if (this.loading) return
      this.loading = true

      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$nextTick(() => {
          const firstError = document.querySelector('.input--invalid')

          if (firstError) {
            firstError.focus()
            firstError.scrollTo()
          }

          this.loading = false
        })
      } else {
        this.storeAllStartData({
          portationTime: this.portationTime_,
          portationConsent: this.portationConsent_,
          nextStep: this.nextStep
        }).then(
          () => {
            this.loading = false
          },
          () => {
            this.loading = false
          }
        )
      }
    }
  },
  mixins: [
    validationMixin,
    isValid,
    slotProxy(['Stepper']),
    processSteps(stepName, stepName, nextProcessStep), // prev = current, because first step
    syncProperty('portationTime', 'portationTime_'),
    syncProperty('portationConsent', 'portationConsent_')
  ],
  validations() {
    return {
      portationConsent: {
        required,
        sameAs: sameAs(() => true)
      },
      portationTime: {
        required
      }
    }
  }
}
</script>
